export const Dialog = {
    // binding and listening for <esc> to close top most dialog
    init: function () {
        $(document.body).on('click', 'a.js-dialog', Dialog.load);
        $(document.body).on('submit', 'form.js-dialog', Dialog.load);
        $(window).keydown(function (e) {
            if ((27 == e.which) && !e.ctrlKey && !e.shiftKey) {
                var t = $('body > div.dialog:last')[0];
                if (t) {
                    // @ts-ignore
                    Dialog.destroy.apply(t.link);
                }
            }
        });
    },
    open: function (url) {
        $('<a/>').attr('href', url).click(Dialog.load).click();
    },
    // load a link into a dialog
    load: function () {
        // dialog already displayed ?
        if (this.dialog && this.dialog.$div) {
            alert('Popup déja ouvert!');
            return false;
        }

        let method, url, data;
        switch (this.nodeName) {
            case 'A':
                url = this.href;
                data = null;
                method = 'get';
                break;
            case 'FORM':
                url = this.action;
                data = $(this).serialize();
                method = this.method;
                break;
            default:
                alert('Unhandled class js-dialog on <' + this.nodeName + '>');
                return false;
        }

        this.dialog = {};
        $.ajax({
            context: this,
            headers: {
                "X-Modal": "1",
            },
            url: url,
            type: method.toUpperCase(),
            data: data,
            success: Dialog.ajaxCallback
        });
        return false;
    },
    // destorys a dialog
    destroy: function () {
        // destroy dialog
        this.dialog.$div.modal("hide");
        this.dialog = {};
    },
    // callback for ajax call
    ajaxCallback: function (data) {
        // json
        if ('object' == typeof data) {
            if (data.reload) {
                window.location.reload();
            } else if (data.ajaxNew && this.dataset.ajaxnew) {
                let option = new Option(data.ajaxNew.text, data.ajaxNew.id, false, false);
                $(this.dataset.ajaxnew).append(option).val(data.ajaxNew.id).change();
                this.dialog.$div.modal("hide");
            } else if (this.dataset.grid) {
                // @ts-ignore
                $(this.dataset.grid).yiiGridView("applyFilter");
                this.dialog.$div.modal("hide");
            } else {
                alert('Unknown Result, see console');
            }
        }
        // html
        else {
            // create dialog if needed
            if (!this.dialog.$div) {
                this.dialog.$div = $(`
                    <div class="modal fade" id="myModal" role="dialog">
                      <div class="modal-dialog">
                        <div class="modal-content">
                          <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                          </div>
                          <div class="modal-body" style="padding: 0;"></div>
                        </div>
                      </div>
                    </div>`).appendTo('body');

                // destroy the modal on hide
                this.dialog.$div.on('hidden.bs.modal', function (e) {
                    Dialog.destroy.apply(this.link);
                });
                // focus on first input upon display
                this.dialog.$div.on('shown.bs.modal', function (e) {
                    $('form input:text:visible:first', this).focus();
                });
            }

            // load html into modal
            this.dialog.$div.find('.modal-body').html(data);

            if ((<any>window).initFuzzySelect) {
                (<any>window).initFuzzySelect(this.dialog.$div);
            }

            // move the title to the header
            this.dialog.$div.find('.modal-header h3.card-title').remove();
            this.dialog.$div.find('.modal-header').prepend(this.dialog.$div.find('h3.card-title'));

            if (0 === this.dialog.$div.find('.card-header *').length) {
                this.dialog.$div.find('.card-header').remove();
            }


            // show the dialog
            this.dialog.$div.modal("show");

            // dialog width ?
            var m = data.match(/dialog-width-(\d+)/);
            if (m) this.dialog.$div.css({
                width: m[1],
                marginLeft: -m[1] / 2
            });

            // update dialog and show if hidden
            this.dialog.$div[0].link = this; // DO NOT MOVE THIS LINE

            // turn forms into ajax forms
            var _this = this;
            $('form', this.dialog.$div).on("submit", function () {
                $('input[type=submit]', this).attr('disabled', "disabled").addClass('disabled');
                $.ajax({
                    url: (this as HTMLFormElement).action,
                    type: (this as HTMLFormElement).method,
                    context: _this,
                    data: $(this).serialize(),
                    success: Dialog.ajaxCallback
                });
                return false;
            });
        }
    }
};
